import { useEffect, useState } from 'react';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { handleErrorResponse } from '../../../_helpers/handleResponse.helper';
import { StandardViewPanel } from '../../../_components/panel/standardView.panel';
import { clientService } from '../../../_services/client.service';
import { getDateString } from '../../../_helpers/dateTime.helper';
import { ClientCareInfoManageDrawer } from './client-careInfoManageDrawer';

export const ClientCareInfoPanel = () => {
    const { clientId } = useParams<{ clientId: string }>();
    const [data, setData] = useState<any>({ items: [] });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const fetchData = async () => {
        if (!clientId) return;
        setIsLoading(true);
        return await clientService.getLatest(clientId)
            .then(
                json => {
                    setData(json);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        fetchData();
    }, [clientId]);

    const rows = [
        { label: 'LHO Area', value: data.lhoAreaName },
        { label: 'Care Status', value: data.careStatusName },
        { label: 'Date of Admission', value: data.dateOfAdmission ? getDateString(data.dateOfAdmission) : "" },
        { label: 'Keyworker 1', value: data.primaryKeyWorkerName },
        { label: 'Keyworker 2', value: data.secondaryKeyWorkeryName },
        { label: 'Case Manager', value: data.caseManagerName },
    ]

    return (
        <>
            <StandardViewPanel
                title="Care Info" buttons={[
                    { icon: "edit", onClick: () => { navigate("ManageCareInfo/") } }
                ]} 
                loading={isLoading}
                items={rows} />
            <Routes>
                <Route path="ManageCareInfo/" element={<ClientCareInfoManageDrawer onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate(""); fetchData(); }} />} />
            </Routes>
        </>
    );
};